import React from "react";
import { LoadingPopup, B2BSpinner, PoweredByHopper } from "halifax";
import { BookingInProgressModalConnectorProps } from "./container";
import "./styles.scss";
import { useEffect } from "react";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import { VIEWED_HOTEL_BOOK_PROCESSING } from "redmond";
import dayjs from "dayjs";
import { RouteComponentProps } from "react-router";

export interface IBookingInProgressModalProps
  extends BookingInProgressModalConnectorProps,
    RouteComponentProps {
  isBookingHome?: boolean;
}

export const BookingInProgressModal = ({
  inProgress,
  priceQuoteInProgress,
  reservation,
  isBookingHome,
}: IBookingInProgressModalProps) => {
  const startTime = dayjs();
  useEffect(() => {
    if (!inProgress && reservation) {
      trackEvent({
        eventName: VIEWED_HOTEL_BOOK_PROCESSING,
        properties: {
          runtime: dayjs().diff(startTime, "seconds", true),
        },
      });
    }
  }, [inProgress, reservation]);
  return (
    <LoadingPopup
      indicatorSize={"small"}
      indicator={B2BSpinner}
      open={inProgress || priceQuoteInProgress}
      popupSize={"small"}
      message={
        priceQuoteInProgress
          ? "Saving travelers and checking availability"
          : `Booking your ${isBookingHome ? "Premium Stay" : "hotel"}`
      }
      footer={PoweredByHopper}
    />
  );
};
